import { z } from 'zod'
import type UserFilteringData from '../../common/server/api/v2/filters/index.get'
import debug from '../../common/utils/console'

const logger = debug.extend('plugins:filters')
export const UserFilteringSchema = z.object({
  userAgent: z.string().nullable(),
  countryCode: z.string(),
  isMobile: z.boolean().default(false),
})

export type UserFilteringData = z.infer<typeof UserFilteringSchema>

const defaultUserFilteringData = UserFilteringSchema.parse({
  countryCode: 'US',
  userAgent: null,
})

/**
 * Fetches user filtering data from the server and provides it to the Nuxt app.
 */
export default defineNuxtPlugin(async (nuxtApp) => {
  try {
    const url = `/api/v2/filters`
    const userGeoData = await $fetch<UserFilteringData>(url)

    const filters = {
      ...userGeoData,
      // this may change to be FF controlled or overwritten
      isMobile: userGeoData.userAgent?.includes('Mobile') || false,
    }
    const parsedFilters = UserFilteringSchema.safeParse(filters)
    if (!parsedFilters.success) {
      logger.warn('Invalid user filtering data:', parsedFilters.error)
      nuxtApp.provide('filters', defaultUserFilteringData)
      return
    }

    nuxtApp.provide('filters', parsedFilters.data)
  } catch (error) {
    logger.warn('Error fetching user filtering data:', error)
    nuxtApp.provide('filters', defaultUserFilteringData)
  }
})
